
(function() {
  var result = { translations: { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206", "days": "{{ days }}\u65E5", "shortForm": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "days": "{{ days }}\u65E5", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} Q{{quarterNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u3001\u5185\u7DDA{{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.860"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.860",
    "ar-eg": "static-7.860",
    "bg": "static-7.860",
    "bn": "static-7.860",
    "ca-es": "static-7.860",
    "cs": "static-7.860",
    "da": "static-7.860",
    "de": "static-7.860",
    "el": "static-7.860",
    "en-gb": "static-7.860",
    "en": "static-7.860",
    "es-mx": "static-7.860",
    "es": "static-7.860",
    "fi": "static-7.860",
    "fr-ca": "static-7.860",
    "fr": "static-7.860",
    "he-il": "static-7.860",
    "hr": "static-7.860",
    "hu": "static-7.860",
    "id": "static-7.860",
    "it": "static-7.860",
    "ja": "static-7.860",
    "ko": "static-7.860",
    "lt": "static-7.860",
    "ms": "static-7.860",
    "nl": "static-7.860",
    "no": "static-7.860",
    "pl": "static-7.860",
    "pt-br": "static-7.860",
    "pt-pt": "static-7.860",
    "ro": "static-7.860",
    "ru": "static-7.860",
    "sk": "static-7.860",
    "sl": "static-7.860",
    "sv": "static-7.860",
    "th": "static-7.860",
    "tl": "static-7.860",
    "tr": "static-7.860",
    "uk": "static-7.860",
    "vi": "static-7.860",
    "x-pseudo": "static-7.860",
    "zh-cn": "static-7.860",
    "zh-hk": "static-7.860",
    "zh-tw": "static-7.860"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.860'}); }
})();


